import React, { useMemo } from 'react';

import { useQuery } from '@tanstack/react-query';

import SettingsContainer from '../../../SettingsContainer';

import useSettingsForm from '../../../../../forms/loan/settings';
import LoanService from '../../../../../services/LoanService';
import { useUiContext } from '../../../../../context/UiContext';
import AccountService from '../../../../../services/AccountService';

export default function Settings({ loan, isVisible, loanId, isLender }) {
  const { showToast } = useUiContext();

  const { data: accounts } = useQuery({
    queryKey: ['accountsSettings'],
    queryFn: AccountService.getAccounts,
    enabled: !!loan && !isLender,
  });

  const saveSettings = async (formValues) => {
    try {
      await LoanService.updateLoan({ formValues, loanId });
      showToast({
        text: 'Settings saved',
        type: 'success',
      });
    } catch (error) {
      showToast({
        text: 'Something went wrong',
        type: 'error',
      });
    }
  };

  let defaultPaymentWaterfall = [];
  const defaultPaymentWaterFallFromAccounts = useMemo(
    () =>
      accounts?.map((account) => ({
        account_id: account.id,
        sequence: account.default_sequence,
      })),
    [accounts]
  );

  if (loan?.payment_waterfall.length > 0) {
    defaultPaymentWaterfall = loan.payment_waterfall;
  } else if (accounts?.length > 0) {
    defaultPaymentWaterfall = defaultPaymentWaterFallFromAccounts;
  }

  const settingsForm = useSettingsForm(
    saveSettings,
    {
      ...loan,
      payment_waterfall: defaultPaymentWaterfall,
    },
    isLender,
    loan?.lender_id
  );

  return <SettingsContainer form={settingsForm} isVisible={isVisible} />;
}
